import {
    FunctionCategoryAnchor,
    FunctionCategoryVersion,
} from 'src/models/anchor-and-version/function-category.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-function-category-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudFunctionCategoryModalComponent extends CrudModalAbstractComponent<
    FunctionCategoryAnchor,
    FunctionCategoryVersion
> {
    public modalProps: ModalProps = {
        title: 'Function Category',
        anchorFields: [
            {
                field: 'functionCategoryId',
                label: 'Function Category ID',
                type: 'number',
                required: true,
                order: 2,
                uniqueCheck: true,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 3 },
            {
                field: 'englishDefinition',
                label: 'Definition',
                type: 'textarea',
                required: true,
                order: 4,
            },
            { field: 'swedishName', label: 'Swedish Name', type: 'text', required: true, order: 5 },
            { field: 'swedishDefinition', label: 'Swedish Definition', type: 'textarea', order: 6 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 7 },
        ],
    };
}
